import InventoryService from "../services/InventoryService";

export default {
  namespaced: true,
  state: {
    inventoryData: null
  },
  getters: {
    getInventoryData: state => state.inventoryData,
    getInventoryStatusCode: state => state.inventoryData?.InventoryStatusCode,
    getSAPStatusCode: state => {
      if (!state.inventoryData) {
        return;
      }
      return state.inventoryData.SAPPricingInfo?.LeadTime;
    }
  },
  mutations: {
    UPDATE_INVENTORY(state, newInventoryData) {
      state.inventoryData = newInventoryData;
    },
    CLEAR_INVENTORY(state) {
      this._vm.$set(state, "inventoryData", null);
    }
  },
  actions: {
    loadInventoryData({ commit }, { productNumber, customerNumber }) {
      return InventoryService.getInventory(productNumber, customerNumber)
        .then(({ data }) => data)
        .then(data => commit("UPDATE_INVENTORY", data))
        .catch(e => {
          // TODO: error handling
          throw e;
        });
    },
    clearProductResource({ commit }) {
      return commit("CLEAR_INVENTORY");
    }
  }
};
